var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0a1.563 1.563 0 011.563 1.563v9.374h9.374a1.563 1.563 0 010 3.126h-9.375v9.374a1.563 1.563 0 01-3.124 0v-9.375H1.562a1.563 1.563 0 110-3.124h9.376V1.562A1.563 1.563 0 0112.5 0z",
    fill: "#6C5AFC"
  })));
}
export default SvgLedPlusIcon;